/**
 * Просмотр (U-17) и кадр (U-16) фото — отдельными чанками, как просмотрщик
 * вложений в чате: они нужны только по действию, а стартовый чанк §11.1 общий для
 * всех экранов. Статический импорт `ZoomableImage` втягивал в него весь C-09.
 */
import { lazy, Suspense, type ComponentProps } from 'react'

const PhotoViewerChunk = lazy(async () => ({ default: (await import('./PhotoViewer')).PhotoViewer }))
const PhotoCropperChunk = lazy(async () => ({ default: (await import('./PhotoCropper')).PhotoCropper }))

export function LazyPhotoViewer(props: ComponentProps<typeof PhotoViewerChunk>): React.ReactElement {
  return (
    <Suspense fallback={null}>
      <PhotoViewerChunk {...props} />
    </Suspense>
  )
}

export function LazyPhotoCropper(props: ComponentProps<typeof PhotoCropperChunk>): React.ReactElement {
  return (
    <Suspense fallback={null}>
      <PhotoCropperChunk {...props} />
    </Suspense>
  )
}
